import { uuid4 } from '@sentry/utils'
import React from 'react'

import useIntegration from '@/hooks/useIntegration'

interface QuestionIntegration {
  id?: string | undefined
  question?: number | string | undefined
  type?: string | undefined
  field?: string | undefined
  field_label?: string | undefined
  is_list?: boolean | undefined
  isNew?: boolean | undefined
  hasChanged?: boolean | undefined
}

function useQuestionIntegration() {
  const { integrationOptions, getIntegrationOptionsValue } = useIntegration()

  const defineType = React.useCallback(
    (type: string | undefined, field: string | undefined) => {
      if (
        type ||
        !field ||
        !integrationOptions ||
        !getIntegrationOptionsValue
      ) {
        return type
      }

      let definedType = type
      Object.keys(integrationOptions).forEach((key) => {
        const options = getIntegrationOptionsValue(key, undefined, true) ?? []
        options.forEach((option) => {
          if (option.value === field) {
            definedType = key
            return
          }
        })
      })
      return definedType
    },
    [integrationOptions, getIntegrationOptionsValue]
  )

  const makeQuestionIntegration = React.useCallback(
    ({
      id,
      question,
      type,
      field,
      field_label,
      is_list,
      isNew,
    }: QuestionIntegration) => {
      return {
        id: id ?? uuid4(),
        question,
        field,
        field_label,
        is_list,
        type: defineType(type, field),
        isNew,
      }
    },
    [defineType]
  )

  return {
    makeQuestionIntegration,
  }
}

export default useQuestionIntegration
